<template>
  <section>
    <v-card>
      <v-card-text>
        <v-alert dark dense prominent color="primary" icon="mdi-school" class="mb-0">
          Extra tasks for candidate
        </v-alert>
      </v-card-text>
      <v-divider/>
      <v-card-text>
        <v-text-field v-for="(task, idx) in tasks" :key="idx"
                      v-model="task.body" dense outlined
                      @click:append-outer="destroy(task)"
                      @change="update(task)"
                      :append-outer-icon="'mdi-delete'"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-text-field label="Task"
                      v-model="body"
                      :append-outer-icon="'mdi-send'"
                      filled
                      clearable
                      type="text"
                      @click:append-outer="create"
                      @click:clear="clearCreateInput"
                      @keyup.enter="create"
        ></v-text-field>
      </v-card-actions>
    </v-card>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    tasks: [],
    body: ''
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tasks = await this.axios.get(`api/mocks/${this.$route.params.mock_id}/additional-tasks`)
          .then(({data}) => data.data)
    },
    create() {
      if(this.body === '') return;
      this.api_errors = []
      this.axios.post(`api/mocks/${this.$route.params.mock_id}/additional-tasks`, {body: this.body})
          .then(({data}) => {
            this.tasks.push(data.data)
            this.clearCreateInput()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
          .then(() => {this.app_loading = false})
    },
    clearCreateInput() {
      this.body = ''
    },
    update(task) {
      this.axios.put(`api/mocks/${this.$route.params.mock_id}/additional-tasks/${task.id}`, task)
          .then(() => {this.$notify('Updated', 'success')})
    },
    destroy(task) {
      this.axios.delete(`api/mocks/${this.$route.params.mock_id}/additional-tasks/${task.id}`)
          .then(() => {
            this.$notify('Deleted', 'success')
            this.loadData()
          })
    },
  }
}
</script>